import { useTranslation } from 'react-i18next';
import { cn } from './cn';

/** A static grey placeholder bar (no shimmer: motion is kept for the space touches); size it with classes (`h-4 w-32`). */
export function Skeleton({ className }: { className?: string }) {
  return <span aria-hidden className={cn('block h-4 rounded bg-muted', className)} />;
}

/** A generic loading block (a few lines), announced as loading. */
export function SkeletonBlock({ lines = 4, className }: { lines?: number; className?: string }) {
  const { t } = useTranslation();
  return (
    <div role="status" aria-label={t('loading')} className={cn('flex flex-col gap-3 py-2', className)}>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} className={i === 0 ? 'w-1/3' : i % 2 ? 'w-full' : 'w-5/6'} />
      ))}
    </div>
  );
}
